import { defineStore } from 'pinia';

import { getBrandingPresets, type BrandingPreset } from '@/branding/presets';
import { configurationsService } from '@/services/configurations.service';

export interface ConfigurationDto {
  key: string;
  value: unknown;
}

export const useConfigurationStore = defineStore('configurationStore', {
  state: () => ({
    configurations: [] as ConfigurationDto[],
    isLoaded: false,
  }),
  getters: {
    brandingPresets: (state): BrandingPreset[] => {
      const presets = state.configurations.find((configuration) => configuration.key === 'branding.presets')?.value;
      return getBrandingPresets(presets as BrandingPreset[] | null | undefined);
    },
  },
  actions: {
    async init() {
      if (this.isLoaded) {
        return;
      }

      await this.fetchConfigurations();
    },
    async fetchConfigurations() {
      this.configurations = await configurationsService.getConfigurations();
      this.isLoaded = true;
    },
  },
});
